import React from 'react';
import {useTranslation} from 'react-i18next';
import ModeBtn from '../../modeBtn/ModeBtn';
import Btn from '../../button/btn/Btn';
import * as css from './BottomSection.css';
import {useField, useFormikContext} from 'formik';
import {updateEventSettings} from '../../../redux/event/eventActions';
import {useSelector} from 'react-redux';

const BottomSection = () => {
    const {t} = useTranslation('event');
    const form=useFormikContext();
    const publishEventXHR= useSelector((s: any) => s.event.publishEventXHR)??null;

    const [{value: privateEvent},,helper] = useField('privateEvent');
    const handleSave =  (e) => {
        form.handleSubmit(e);
    };
    const handlePrivateToggle = () => {
        if(!privateEvent) {
            form.setFieldValue('showInLive', false);
            form.setFieldValue('tickchakIndex', false);
            form.setFieldValue('glatticketIndex', false);
            updateEventSettings('isIndexed', 0, 'event').then();
        }
        helper.setValue(!privateEvent);
    };
    return (
        <css.bottom>
            <ModeBtn className={''} status={privateEvent} click={handlePrivateToggle} dataCyName={'privateEvent'} requestStatus={undefined} dataTitle={undefined} text={undefined}/>
            <css.privateText>
                <span>{t('privateEvent')}</span>{t('privateEventDesc')}
            </css.privateText>
            <Btn disabled={!form.dirty} onClick={handleSave} className={publishEventXHR}>
                {t('save')}
            </Btn>
        </css.bottom>
    );
};

export default BottomSection;
